import { FrontendEnvironment } from './environment.model';

export const environment: FrontendEnvironment = {
  profile: 'pre',
  production: false,
  appUrl: 'https://pre.eaea.carlospajuelo.com',
  apiBaseUrl: 'https://pre.eaea.carlospajuelo.com/api',
};
